import BsBaseController from './_base_controller'
import Toast from 'bootstrap/js/src/toast'

// usage:
//  .toast-container {
//    data-controller="bs--tab"
//  }
export default class extends BsBaseController {
  connect () {
    super.connect()
    this._bsComponent.show()
  }

  _setAttributes () {
    // toast do NOT use bs-toggle
    // super._setAttributes("toast")
  }

  _createBsComponent () {
    return new Toast(this.element)
  }
}
